import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditServicemenForm from "../components/EditServicemenForm";

const EditServicemenPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Servicemen' />

                <EditServicemenForm />

            </MasterLayout>
        </>
    );
};

export default EditServicemenPage;
